import { SUPPORT_SECTION_TRANSLATION_KEY } from '../constants';

export default {
  [SUPPORT_SECTION_TRANSLATION_KEY]: {
    SUPPORT_SECTION_TITLE: 'Need help?',
    SUPPORT_SECTION_DESCRIPTION:
      'We are here to assist you! Choose the type of support based on what you need to resolve.',
  },
};
